import {
  greenWallet,
  orangeCoin,
  orangeGrowth,
  purpleGrowth,
} from "@/common/components/icons/svg-icons";
import { IDRFBalance, IRequestMade, KeyValueObj } from "@/common/types/others";
import { IAuthUser } from "@/common/types/user";

export const hospitalHeadFinancialCards = (data: IDRFBalance) => [
  {
    id: 1,
    title: "DRF Balance",
    value: data?.drf_balance,
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    title: "Recent Fund Allocation",
    value: data?.recent_fund_allocations,
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    title: "Total Allocations",
    value: data?.total_allocations,
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    title: "Total Request Submitted",
    value: data?.total_requests_submitted,
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const newFundRequestForm = (data: IAuthUser) => [
  {
    inputType: "label",
    label: "Requesting Officer Details",
  },
  {
    inputType: "text",
    name: "firstName",
    prompt: "First Name",
    rules: { required: true },
    readOnly: true,
    initialValue: data?.first_name,
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "lastname",
    prompt: " Last Name",
    readOnly: true,
    initialValue: data?.last_name,
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    initialValue: data?.email,
    readOnly: true,
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "number",
    prompt: "Phone Number",
    readOnly: true,
    initialValue: data?.company?.phone_number,
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "label",
    label: "Request Information",
  },
  {
    inputType: "text",
    name: "request_amount",
    prompt: "Request Amount",
    placeholder: "120,000",
    required: true,
    isFullWidth: true,
  },
  {
    inputType: "textarea",
    name: "justification",
    prompt: "Purpose of request",
    placeholder: "make it worth it",
    required: true,
    isFullWidth: true,
  },
];

// ======== Financial Information ========

export const headOfPharmacyTableHeaders = [
  "Request Date",
  "Submitted By",
  "Amount Requested",
  "Status",
];

export const headOfPharmacyTableKeys = [
  "request_date",
  "submitted_by",
  "amount_requested",
  "status",
];

export const getHeadOfPharmacyTableData = (data: IRequestMade[]) => {
  if (!data || data.length === 0) return [];

  const result = data?.map((dataItem) => ({
    id: dataItem.id,
    request_date: { value: dataItem.created_at, type: "string" },
    submitted_by: { value: dataItem.facility_name, type: "string" },
    amount_requested: { value: dataItem.requested_amount, type: "string" },
    status: { value: dataItem.status, type: "string" },
    justification: {
      value: dataItem.justification,
      type: "string",
    },
  }));
  return result;
};

export const getHeadOfHospitalTableData = (data: IRequestMade[]) => {
  if (!data || data.length === 0) return [];

  const result = data?.map((dataItem) => ({
    id: { value: dataItem.id, type: "string" },
    request_date: { value: dataItem.created_at, type: "string" },
    submitted_by: { value: dataItem.facility_name, type: "string" },
    amount_requested: { value: dataItem.requested_amount, type: "string" },
    status: { value: dataItem.status, type: "string" },
    justification: {
      value: dataItem.justification,
      type: "string",
    },
  }));
  return result;
};

export const headOfHospitalTableHeaders = [
  "Request Date",
  "Submitted By",
  "Amount Requested",
  "Status",
];

export const headOfHospitalTableKeys = [
  "request_date",
  "submitted_by",
  "amount_requested",
  "status",
];

export const getRequestDetailsData = (data: KeyValueObj) => {
  return {
    id: data?.id,
    submittion_date: data?.request_date?.value,
    submitted_by: data?.submitted_by?.value,
    amount_requested: data?.amount_requested?.value,
    status: data?.status?.value,
    justification: data?.justification?.value,
  };
};

// ======== Report Information ========
export const stockLevelReportTableHeaders = [
  "ATC Code-Name",
  "Packaging Type",
  "Qty Available",
  "Threshold",
  "% Below Threshold",
  "Last Restocked",
];

export const stockeLevelTableKey = [
  "atc_code_name",
  "package_type",
  "qty_available",
  "threshold",
  "below_threshold",
  "last_restock",
];

export const getStockLevelTableData = () => [
  {
    id: "1",
    atc_code_name: { value: "Paracetamol", type: "string" },
    package_type: { value: "Blister Pack", type: "string" },
    qty_available: { value: "120", type: "string" },
    threshold: { value: "150", type: "string" },
    below_threshold: { value: "30", type: "string" },
    last_restock: { value: "2025-06-10", type: "string" },
  },
  {
    id: "2",
    atc_code_name: { value: "Amoxicillin", type: "string" },
    package_type: { value: "Bottle", type: "string" },
    qty_available: { value: "300", type: "string" },
    threshold: { value: "250", type: "string" },
    below_threshold: { value: "0", type: "string" },
    last_restock: { value: "2025-07-01", type: "string" },
  },
  {
    id: "3",
    atc_code_name: { value: "Metronidazole", type: "string" },
    package_type: { value: "Sachet", type: "string" },
    qty_available: { value: "40", type: "string" },
    threshold: { value: "100", type: "string" },
    below_threshold: { value: "60", type: "string" },
    last_restock: { value: "2025-06-20", type: "string" },
  },
  {
    id: "4",
    atc_code_name: { value: "Ibuprofen", type: "string" },
    package_type: { value: "Tube", type: "string" },
    qty_available: { value: "200", type: "string" },
    threshold: { value: "180", type: "string" },
    below_threshold: { value: "0", type: "string" },
    last_restock: { value: "2025-06-15", type: "string" },
  },
  {
    id: "5",
    atc_code_name: { value: "Ciprofloxacin", type: "string" },
    package_type: { value: "Vial", type: "string" },
    qty_available: { value: "60", type: "string" },
    threshold: { value: "100", type: "string" },
    below_threshold: { value: "40", type: "string" },
    last_restock: { value: "2025-05-30", type: "string" },
  },
  {
    id: "6",
    atc_code_name: { value: "Artemether/Lumefantrine", type: "string" },
    package_type: { value: "Injection", type: "string" },
    qty_available: { value: "85", type: "string" },
    threshold: { value: "90", type: "string" },
    below_threshold: { value: "5", type: "string" },
    last_restock: { value: "2025-06-25", type: "string" },
  },
  {
    id: "7",
    atc_code_name: { value: "Loratadine", type: "string" },
    package_type: { value: "Tablet", type: "string" },
    qty_available: { value: "500", type: "string" },
    threshold: { value: "400", type: "string" },
    below_threshold: { value: "0", type: "string" },
    last_restock: { value: "2025-07-05", type: "string" },
  },
  {
    id: "8",
    atc_code_name: { value: "Salbutamol", type: "string" },
    package_type: { value: "Inhaler", type: "string" },
    qty_available: { value: "25", type: "string" },
    threshold: { value: "50", type: "string" },
    below_threshold: { value: "25", type: "string" },
    last_restock: { value: "2025-06-18", type: "string" },
  },
  {
    id: "9",
    atc_code_name: { value: "Azithromycin", type: "string" },
    package_type: { value: "Capsule", type: "string" },
    qty_available: { value: "140", type: "string" },
    threshold: { value: "130", type: "string" },
    below_threshold: { value: "0", type: "string" },
    last_restock: { value: "2025-07-02", type: "string" },
  },
  {
    id: "10",
    atc_code_name: { value: "Insulin", type: "string" },
    package_type: { value: "Ampoule", type: "string" },
    qty_available: { value: "70", type: "string" },
    threshold: { value: "80", type: "string" },
    below_threshold: { value: "10", type: "string" },
    last_restock: { value: "2025-06-22", type: "string" },
  },
];

export const expiredDrugReportTableHeader = [
  "ATC Code-Name",
  "Batch Number",
  "Manufacture Date",
  "Expiry Date",
  "Days to Expiry",
];

export const expiredDrugReportTableKey = [
  "atc_code_name",
  "batch_number",
  "manufacture_date",
  "expiry_date",
  "days_of_expiry",
];

export const getExpiredDrugReportTableData = (data: KeyValueObj) => [
  {
    id: data?.id || "1",
    atc_code_name: { value: "Amoxicillin", type: "string" },
    batch_number: { value: "AMX12345", type: "string" },
    manufacture_date: { value: "2023-01-15", type: "string" },
    expiry_date: { value: "2025-06-01", type: "string" },
    days_of_expiry: { value: "44", type: "string" },
  },
  {
    id: "2",
    atc_code_name: { value: "Ciprofloxacin", type: "string" },
    batch_number: { value: "CIP87654", type: "string" },
    manufacture_date: { value: "2022-12-10", type: "string" },
    expiry_date: { value: "2025-05-30", type: "string" },
    days_of_expiry: { value: "46", type: "string" },
  },
  {
    id: "3",
    atc_code_name: { value: "Ibuprofen", type: "string" },
    batch_number: { value: "IBU54321", type: "string" },
    manufacture_date: { value: "2022-09-05", type: "string" },
    expiry_date: { value: "2025-07-01", type: "string" },
    days_of_expiry: { value: "14", type: "string" },
  },
  {
    id: "4",
    atc_code_name: { value: "Paracetamol", type: "string" },
    batch_number: { value: "PAR09876", type: "string" },
    manufacture_date: { value: "2023-03-20", type: "string" },
    expiry_date: { value: "2025-06-20", type: "string" },
    days_of_expiry: { value: "25", type: "string" },
  },
  {
    id: "5",
    atc_code_name: { value: "Lisinopril", type: "string" },
    batch_number: { value: "LIS44556", type: "string" },
    manufacture_date: { value: "2022-07-30", type: "string" },
    expiry_date: { value: "2025-05-15", type: "string" },
    days_of_expiry: { value: "61", type: "string" },
  },
  {
    id: "6",
    atc_code_name: { value: "Metronidazole", type: "string" },
    batch_number: { value: "MET33445", type: "string" },
    manufacture_date: { value: "2023-05-10", type: "string" },
    expiry_date: { value: "2025-06-25", type: "string" },
    days_of_expiry: { value: "20", type: "string" },
  },
  {
    id: "7",
    atc_code_name: { value: "Amlodipine", type: "string" },
    batch_number: { value: "AML77889", type: "string" },
    manufacture_date: { value: "2022-06-18", type: "string" },
    expiry_date: { value: "2025-06-15", type: "string" },
    days_of_expiry: { value: "30", type: "string" },
  },
  {
    id: "8",
    atc_code_name: { value: "Salbutamol", type: "string" },
    batch_number: { value: "SAL55443", type: "string" },
    manufacture_date: { value: "2023-02-01", type: "string" },
    expiry_date: { value: "2025-07-10", type: "string" },
    days_of_expiry: { value: "5", type: "string" },
  },
  {
    id: "9",
    atc_code_name: { value: "Artemether/Lumefantrine", type: "string" },
    batch_number: { value: "ART11223", type: "string" },
    manufacture_date: { value: "2023-04-12", type: "string" },
    expiry_date: { value: "2025-06-28", type: "string" },
    days_of_expiry: { value: "17", type: "string" },
  },
  {
    id: "10",
    atc_code_name: { value: "Insulin", type: "string" },
    batch_number: { value: "INS66778", type: "string" },
    manufacture_date: { value: "2022-08-01", type: "string" },
    expiry_date: { value: "2025-05-25", type: "string" },
    days_of_expiry: { value: "51", type: "string" },
  },
];

export const financialReportTableHeader = [
  "Month",
  "Total Sales",
  "Sales Revenue",
  "Restocking Cost",
  "Net Balance",
];

export const financialReportTableKey = [
  "month",
  "total_sales",
  "sales_revenue",
  "restocking_cost",
  "net_balance",
];

export const getFinancialReportTableData = (data: KeyValueObj) => [
  {
    id: data?.id || "1",
    month: { value: "January", type: "string" },
    total_sales: { value: "4200", type: "string" },
    sales_revenue: { value: "1050000", type: "string" },
    restocking_cost: { value: "600000", type: "string" },
    net_balance: { value: "450000", type: "string" },
  },
  {
    id: "2",
    month: { value: "February", type: "string" },
    total_sales: { value: "3800", type: "string" },
    sales_revenue: { value: "912000", type: "string" },
    restocking_cost: { value: "550000", type: "string" },
    net_balance: { value: "362000", type: "string" },
  },
  {
    id: "3",
    month: { value: "March", type: "string" },
    total_sales: { value: "5000", type: "string" },
    sales_revenue: { value: "1300000", type: "string" },
    restocking_cost: { value: "700000", type: "string" },
    net_balance: { value: "600000", type: "string" },
  },
  {
    id: "4",
    month: { value: "April", type: "string" },
    total_sales: { value: "4600", type: "string" },
    sales_revenue: { value: "1196000", type: "string" },
    restocking_cost: { value: "650000", type: "string" },
    net_balance: { value: "546000", type: "string" },
  },
  {
    id: "5",
    month: { value: "May", type: "string" },
    total_sales: { value: "3900", type: "string" },
    sales_revenue: { value: "975000", type: "string" },
    restocking_cost: { value: "510000", type: "string" },
    net_balance: { value: "465000", type: "string" },
  },
  {
    id: "6",
    month: { value: "June", type: "string" },
    total_sales: { value: "4800", type: "string" },
    sales_revenue: { value: "1248000", type: "string" },
    restocking_cost: { value: "590000", type: "string" },
    net_balance: { value: "658000", type: "string" },
  },
  {
    id: "7",
    month: { value: "July", type: "string" },
    total_sales: { value: "5300", type: "string" },
    sales_revenue: { value: "1378000", type: "string" },
    restocking_cost: { value: "640000", type: "string" },
    net_balance: { value: "738000", type: "string" },
  },
  {
    id: "8",
    month: { value: "August", type: "string" },
    total_sales: { value: "4100", type: "string" },
    sales_revenue: { value: "1107000", type: "string" },
    restocking_cost: { value: "580000", type: "string" },
    net_balance: { value: "527000", type: "string" },
  },
  {
    id: "9",
    month: { value: "September", type: "string" },
    total_sales: { value: "4700", type: "string" },
    sales_revenue: { value: "1222000", type: "string" },
    restocking_cost: { value: "600000", type: "string" },
    net_balance: { value: "622000", type: "string" },
  },
  {
    id: "10",
    month: { value: "October", type: "string" },
    total_sales: { value: "4500", type: "string" },
    sales_revenue: { value: "1170000", type: "string" },
    restocking_cost: { value: "620000", type: "string" },
    net_balance: { value: "550000", type: "string" },
  },
];

export const auditTrailTableHeader = [
  "Date",
  "Time",
  "User",
  "Action",
  "Details",
];

export const auditTrailTableKey = ["date", "time", "user", "action", "details"];

export const getAuditTrailTableData = (data: KeyValueObj) => [
  {
    id: data?.id || "1",
    date: { value: "2025-07-14", type: "string" },
    time: { value: "09:23:45", type: "string" },
    user: { value: "Babatunde Salami", type: "string" },
    action: { value: "Login", type: "string" },
    details: {
      value: "User logged into the system successfully.",
      type: "string",
    },
  },
  {
    id: "2",
    date: { value: "2025-07-14", type: "string" },
    time: { value: "10:10:03", type: "string" },
    user: { value: "Ngozi Eze", type: "string" },
    action: { value: "Add Record", type: "string" },
    details: {
      value: "Added new drug to inventory: Paracetamol 500mg.",
      type: "string",
    },
  },
  {
    id: "3",
    date: { value: "2025-07-14", type: "string" },
    time: { value: "10:32:17", type: "string" },
    user: { value: "Chinedu Okoro", type: "string" },
    action: { value: "Update", type: "string" },
    details: {
      value: "Updated threshold value for Amoxicillin.",
      type: "string",
    },
  },
  {
    id: "4",
    date: { value: "2025-07-14", type: "string" },
    time: { value: "11:45:55", type: "string" },
    user: { value: "Aisha Mohammed", type: "string" },
    action: { value: "Delete", type: "string" },
    details: {
      value: "Deleted expired record: Batch INS66778.",
      type: "string",
    },
  },
  {
    id: "5",
    date: { value: "2025-07-14", type: "string" },
    time: { value: "12:15:22", type: "string" },
    user: { value: "Babatunde Salami", type: "string" },
    action: { value: "Logout", type: "string" },
    details: { value: "User logged out of the system.", type: "string" },
  },
  {
    id: "6",
    date: { value: "2025-07-13", type: "string" },
    time: { value: "08:59:33", type: "string" },
    user: { value: "Ngozi Eze", type: "string" },
    action: { value: "Generate Report", type: "string" },
    details: {
      value: "Generated financial report for June 2025.",
      type: "string",
    },
  },
  {
    id: "7",
    date: { value: "2025-07-13", type: "string" },
    time: { value: "09:41:12", type: "string" },
    user: { value: "Chinedu Okoro", type: "string" },
    action: { value: "Restock", type: "string" },
    details: {
      value: "Restocked Ibuprofen (200 units added).",
      type: "string",
    },
  },
  {
    id: "8",
    date: { value: "2025-07-13", type: "string" },
    time: { value: "10:25:44", type: "string" },
    user: { value: "Aisha Mohammed", type: "string" },
    action: { value: "Login", type: "string" },
    details: {
      value: "User logged into the system successfully.",
      type: "string",
    },
  },
  {
    id: "9",
    date: { value: "2025-07-12", type: "string" },
    time: { value: "15:50:27", type: "string" },
    user: { value: "Ngozi Eze", type: "string" },
    action: { value: "Approve Request", type: "string" },
    details: { value: "Approved fund request for ₦1,200,000.", type: "string" },
  },
  {
    id: "10",
    date: { value: "2025-07-12", type: "string" },
    time: { value: "16:18:11", type: "string" },
    user: { value: "Chinedu Okoro", type: "string" },
    action: { value: "Reject Request", type: "string" },
    details: {
      value: "Rejected stock increase request for Salbutamol.",
      type: "string",
    },
  },
];
